module.exports = __webpack_public_path__ + "src/assets/img/BNBbull.9d0d310f.png";